export default __webpack_public_path__ + "static/media/gallery-09_full.65969bb1.jpg";